'use client'

import { useRef } from 'react'

import { mapManager } from './map-manager'

export const useCircle = () => {
  const circleRef = useRef<naver.maps.Circle | null>(null)

  const createCircle = (
    options: naver.maps.CircleOptions & { render?: boolean },
  ) => {
    mapManager.withMap(map => {
      circleRef.current = new naver.maps.Circle({
        ...options,
      })

      if (options.render) {
        circleRef.current.setMap(map)
      }
    })
  }

  const removeCircle = () => {
    if (circleRef.current) {
      circleRef.current.setMap(null)
      circleRef.current = null
    }
  }

  const getCircleBounds = () => {
    if (!circleRef.current) return null

    return circleRef.current.getBounds()
  }

  return { createCircle, removeCircle, getCircleBounds }
}
